export default __webpack_public_path__ + "static/media/binance.4927bd5a.png";